<template>
  <div :class="{'-active': loading}">
    <svg>
      <use xlink:href="#icon-loader-new"></use>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'FullPageLoader',
  computed: {
    loading() {
      return this.$store.state.ui.pageLoad
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";
@import "../../../../_src/sass/config/responsive";

div {
  align-items: center;
  background: rgba(black, 0.8);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 300ms ease-out;
  z-index: 9999999;

  &.-active {
    opacity: 1;
    pointer-events: auto;
  }
}

svg {
  animation: 1.5s fade-in-fade-out 0s alternate infinite;
  fill: white;
}

@keyframes fade-in-fade-out {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}
</style>
